import React from 'react';
import { useDataFetcher } from '../../../hooks';
import { Container } from 'react-bootstrap';
import { FormHeading } from '../../../form/formHeading';
import { Well } from '../../../form';
import { RouteButton } from '../../../form/routeButton';
import AjaxErrorBoundary from '../../../ajax/errorBoundary';
import { VisitorAgreementList } from './VisitorAgreementList';

export const VisitorAgreementListPage: React.FC = () => {
  const { busy, errors, data } = useDataFetcher('/api/visitorAgreements');

  const agreements = data?.agreements || [];

  return (
    <Container fluid>
      <Well>
        <FormHeading
          title="Visitor Agreements"
          subTitle="List"
          backPath="/admin"
        />
        <RouteButton className="mb-2" to="/admin/visitorAgreements/create">
          Create a new visitor agreement
        </RouteButton>
        <AjaxErrorBoundary
          busy={busy}
          loadingText="Loading visitor agreements"
          errors={errors}
        >
          <VisitorAgreementList agreements={agreements} />
        </AjaxErrorBoundary>
      </Well>
    </Container>
  );
};
